import { Core } from 'cytoscape';
import { atom, useAtom } from 'jotai';

// Cytoscapeインスタンスをキャッシュするatom
const cytoscapeInstanceAtom = atom<Core | null>(null);

export const useNetworkState = () => {
  // cytoscapeCoreRefObjectをatomから取得（キャッシュとして使用）
  const [cytoscapeCoreRefObject, setCytoscapeCoreRefObject] = useAtom(
    cytoscapeInstanceAtom
  );

  return {
    // cytoscape Core 参照オブジェクト
    cytoscapeCoreRefObject,
    setCytoscapeCoreRefObject,
  };
};
